import { getEnvironmentConfig } from "@airborne/react-admin";
import { HttpTransportType, HubConnectionBuilder, ITransport, LogLevel } from "@microsoft/signalr";
import * as config from "../config";

const envConfig = getEnvironmentConfig(config);
const baseHubUrl = envConfig.apiBaseUrl?.slice(0, -3);

export const SetUpSignalRConnection = async (
  url: string,
  transport: HttpTransportType | ITransport,
  accessToken: string,
  skipNegotiation: boolean = false
) => {
  const connection = new HubConnectionBuilder()
    .withUrl(baseHubUrl + url, {
      skipNegotiation: skipNegotiation,
      transport: transport,
      withCredentials: false,
      accessTokenFactory: () => accessToken,
    })
    .withAutomaticReconnect()
    .configureLogging(LogLevel.Trace)
    .build();
  try {
    await connection.start();
  } catch (err) {
    console.error(err);
  }
  return connection;
};
